<div class="border rounded-lg shadow-sm mb-2 border-0 mt-4">
  <!-- Card Header (now static) -->
  <div class="d-flex justify-content-between align-items-center p-2 bg-green-dark">
    <div class="fw-bold text-xxs">Application progress tracker</div>
    <!-- Removed the dropdown chevron since it's not collapsible -->
  </div>

  <!-- Content (always visible) -->
  <div class="px-3 pb-3 text-xxs bg-white p-3">
    <div class="timeline" :class="{ 'timeline-scrollable': steps.length > 6 }">
      <div v-for="(step, index) in steps" :key="index" class="d-flex position-relative mb-4">
        <!-- Timeline icon -->
        <div class="timeline-icon position-relative d-flex justify-content-center">
          <div :class="[
              'timeline-status-icon',
              step.status === 'completed'
                ? 'bg-success text-white'
                : step.status === 'in-progress'
                ? 'bg-light border border-success text-success'
                : 'bg-light text-muted']">
            <i :class="[step.status === 'completed'
                        ? 'bi bi-check'
                        : step.status === 'in-progress'
                        ? 'bi bi-clock-history'
                        : 'bi bi-info-circle']" class="timeline-status-icon-inner"></i>
          </div>

          <div v-if="index !== steps.length - 1"
            class="timeline-connector position-absolute top-100 start-50 translate-middle-x"></div>
        </div>

        <!-- Step text aligned with icon -->
        <div class="ps-3 flex-grow-1 d-flex flex-column justify-content-center">
          <div class="d-flex align-items-center">
            <div class="text-muted me-2 text-xxs">{{ step.date }}</div>
            <div class="text-dark text-xxs">{{ step.title }}</div>
          </div>

          <!-- Sub-items -->
          <ul class="list-unstyled ps-3 mt-2 mb-0" v-if="step.items && step.items.length">
            <li v-for="(item, idx) in step.items" :key="idx" class="d-flex align-items-center mb-1 text-xxs" :class="{
                'text-success': item.status === 'completed',
                'text-primary': item.status === 'in-progress',
                'text-muted': item.status === 'pending'}">
              <i :class="[
                  'me-2',
                  item.status === 'completed'
                    ? 'bi bi-check-circle-fill'
                    : item.status === 'in-progress'
                    ? 'bi bi-clock-history'
                    : 'bi bi-circle']"></i>
              {{ item.title }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>